import { render, staticRenderFns } from "./InformacoesIA.vue?vue&type=template&id=6685130e&scoped=true&"
import script from "./InformacoesIA.vue?vue&type=script&lang=js&"
export * from "./InformacoesIA.vue?vue&type=script&lang=js&"
import style0 from "./InformacoesIA.vue?vue&type=style&index=0&id=6685130e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6685130e",
  null
  
)

export default component.exports